
import * as ActionTypes from './../constants/ActionTypes'

const initialState = {
  loading: {},
  data_pagin: [],
  data_pagin_notsells: [],
  data: [],
  fields: {

  },
  products_filter: [],
  response: {},
  simpleToast: false,
  price_groups_array: [],
  cash_register_util: {},
  businessLocations: [],


  all_products_server: [],
  all_contacts_server: [],

  networkStatus: false,
  refresh_list: false,
  concat_list: false,
  view_active: '',
  minirepoort: {
    total_pre_sales: 0,
    total_quotations: 1,
    total_sales: 0,
    total_suspended: 0,
    total_transactions: 0
  },

};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ActionTypes.DATA_WITH_PAGINATION_CONCAT:
      return {
        ...state,
        [action.name]: state[action.name].length === 0 ? action.items : state[action.name].concat(action.items)
      };
    case ActionTypes.SET_DATA:
      return Object.assign({}, state, action.items);
    default: return state;
  }
}